import type { PropertyPhoto } from "../interfaces/property";

type NormalizeResult = {
  photos: PropertyPhoto[];
  main?: PropertyPhoto;
};

export const normalizePhotosWithMain = (
  photos: PropertyPhoto[],
  main?: PropertyPhoto,
): NormalizeResult => {
  if (photos.length === 0) {
    return { photos: [], main: undefined };
  }

  const resolvedMain =
    (main && photos.find((p) => p.url === main.url)) || photos[0];
  const remaining = photos.filter((p) => p.url !== resolvedMain.url);
  const ordered = [resolvedMain, ...remaining];
  const normalized = ordered.map((p, idx) => ({ ...p, order: idx }));

  return { photos: normalized, main: resolvedMain };
};
